import { inject, Injectable } from '@angular/core';
import { filter, map } from 'rxjs/operators';
import { ActivatedRoute, NavigationEnd, Router, Scroll } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { Nullable } from '../../shared/shared.types';

const DEFAULT_TITLE = 'SWM more';

@Injectable({
  providedIn: 'root',
})
export class TitleService {
  private $appTitle: string = DEFAULT_TITLE;
  private $pageTitle: Nullable<string> = null;
  private readonly router = inject(Router);
  private readonly activatedRoute = inject(ActivatedRoute);
  private readonly titleService = inject(Title);

  constructor() {
    // Dynamic Page Title: change page title after navigation
    this.router.events
      .pipe(filter(event => {

        return event instanceof NavigationEnd ||
          (event instanceof Scroll && event.routerEvent instanceof NavigationEnd);
      }))
      .pipe(map(() => this.activatedRoute))
      .pipe(filter(route => route.outlet === 'primary'))
      .subscribe(route => {
        this.$appTitle = TitleService.getLowestTitle(route, 'appTitle') ?? DEFAULT_TITLE;
        this.$pageTitle = TitleService.getLowestTitle(route, 'pageTitle');
        this.titleService.setTitle(
          this.$pageTitle
            ? this.$pageTitle + ' | ' + this.$appTitle
            : this.$appTitle,
        );
      });
  }

  get pageTitle(): Nullable<string> {
    return this.$pageTitle;
  }

  get appTitle(): string {
    return this.$appTitle;
  }

  private static getLowestTitle(
    route: ActivatedRoute,
    titleProperty: string,
  ): Nullable<string> {
    // go top down and identify the lowest child
    while (route.firstChild) {
      route = route.firstChild;
    }
    // go bottom up and return the first available appTitle
    while (route.parent) {
      const title = route.snapshot.data[titleProperty];
      if (title != null) {
        // title is defined
        return title;
      } else {
        // if title is not defined search the parents for a title
        route = route.parent;
      }
    }
    return null;
  }
}
